import { AbstractModel } from '../shared/abstract.model';

export class VivoMapping extends AbstractModel {
  vivoId: string;
  type: 'Asset' | 'Organization';
  regoId: string;
}
